import { get } from 'services/request';
import { ILanguage } from './LanguagesModel';

export default class LanguagesSelectModel {
  async get() {
    const languages = await get<ILanguage[]>(`languages`);
    return languages.sort((a, b) => a.name.localeCompare(b.name));
  }
}
